import React, { useState } from 'react';
import { Grid, Typography, Hidden, Box, Tabs, Tab } from '@material-ui/core';
import { Header, Project } from './components';
import expData from './components/Project/ProjectsData';
import uuid from 'uuid/v1';
import Grow from '@material-ui/core/Grow';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';


const AntTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  }
})(Tabs);

const AntTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#84a086',
      opacity: 1,
    },
    '&$selected': {
      color: '#84a086',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#84a086',
    },
  }
}))(props => <Tab disableRipple {...props} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },
  content: {
    marginTop: '1%',
    [theme.breakpoints.up('xs')]: {
      padding: '3% 7% 0% 7%'
    },
    [theme.breakpoints.down('xs')]: {
      padding: '16% 10% 0% 10%'
    },
  },
  padding: {
    padding: theme.spacing(3)
  },
  demo1: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: '5vh'
  },
}));

const Portfolio = () => {
  window.scrollTo(0, 0)
  const classes = useStyles();
  const [projects] = useState(expData);
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Header />
      <div className={classes.demo1}>
        <Hidden xsDown>
          <AntTabs value={value} scrollButtons="auto" onChange={handleChange} aria-label="ant example"
            centered>
            <AntTab label="All" />
            <AntTab label="Desktop" />
            <AntTab label="Frontend" />
            <AntTab label="Backend" />
            {/* <AntTab label="Mobile App" /> */}
          </AntTabs>
        </Hidden>
        <Hidden smUp>
          <AntTabs value={value} scrollButtons="on" onChange={handleChange} aria-label="ant example" variant="scrollable">
            <AntTab label="All" />
            <AntTab label="Desktop" />
            <AntTab label="Frontend" />
            <AntTab label="Backend" />
            {/* <AntTab label="Mobile App" /> */}
          </AntTabs>
        </Hidden>
      </div>
      <div className={classes.content}>
        <Grid
          container
          spacing={3}
        >
          {projects.map(project => {
            if (project.category.includes(value)) return (
              <Grow in={true} key={uuid()}>
                <Grid
                  item
                  key={uuid()}
                  xl={3}
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                >
                  <Project project={project} />
                </Grid>
              </Grow>
            )
            else return (<div key={uuid()}></div>)
          })}
        </Grid>
      </div>
    </div>
  );
};

export default Portfolio;